var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 132 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.571 0H9.42857C6.92796 0 4.52976 0.996837 2.76156 2.77122C0.993364 4.5456 0 6.95218 0 9.46154V85.1538C0 87.6632 0.993364 90.0698 2.76156 91.8442C4.52976 93.6185 6.92796 94.6154 9.42857 94.6154H47.1429V113.538H28.2857V123H103.714V113.538H84.8571V94.6154H122.571C125.072 94.6154 127.47 93.6185 129.238 91.8442C131.007 90.0698 132 87.6632 132 85.1538V9.46154C132 6.95218 131.007 4.5456 129.238 2.77122C127.47 0.996837 125.072 0 122.571 0V0ZM75.4286 113.538H56.5714V94.6154H75.4286V113.538ZM122.571 85.1538H9.42857V9.46154H122.571V85.1538Z",
    fill: "#551FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddScreenIcon);
export default __webpack_public_path__ + "static/media/addScreenIcon.cb3c9334fe7496ca3cd3d41570a37ae8.svg";
export { ForwardRef as ReactComponent };